// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"dc34ae40","145":"3da4eb08","673":"aa209c3e","787":"18830742","898":"11b904d6"}[chunkId] + ".chunk.js";
};